
<div class="flex-row gap-standard">

    <ss-logo-solo [matTooltip]="versionDisplayObs | async" class="logo" *ngIf="isSmallerScreenObs | async;else standardLogo"></ss-logo-solo>

    <ng-template #standardLogo>
        <ss-logo  [matTooltip]="versionDisplayObs | async" class="logo" ></ss-logo>    
    </ng-template>
    
</div>




<ng-container *ngIf="isSmallerScreenObs | async;else standardToolbar">
    <ng-container *ngTemplateOutlet="mobileToolbarTemplateRefSubject | async"></ng-container>
</ng-container>
<ng-template #standardToolbar>
    <ss-toolbar-search *ngIf="searchVisibleSubject | async"></ss-toolbar-search>
</ng-template>

<div class="flex-row gap-standard">

    <button 
        mat-icon-button 
        cdkOverlayOrigin 
        #origin="cdkOverlayOrigin" 
        (click)="userMenuOpenedSubject.next(!userMenuOpenedSubject.value)"
    >
        <mat-icon class="primary-contrast-text">account_circle</mat-icon>
    </button>

    <button 
        *ngIf="isSmallerScreenObs | async"
        mat-icon-button 
        (click)="toggleExpanded()"
    >
        <mat-icon class="primary-contrast-text">menu</mat-icon>
    </button>
</div>



<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="userMenuOpenedSubject | async"
    [cdkConnectedOverlayPositions]="positions"
    cdkConnectedOverlayWidth="325px"
    
>
    <div    class="background-white full-width border-radius-small box-shadow"
            onOutsideClick
            (onOutsideClick)="userMenuOpenedSubject.next(false)"
    >
        <ss-user-menu></ss-user-menu>
    </div>

</ng-template>